export default {
  init() {
    
    jQuery(function ($) {

      $('.clock').each(function (){
        var clock = $(this);
        clock.htAnalogClock({
          hasShadow: false,
  
          drawSecondHand: true,
          drawMajorTicks: true,
          drawMinorTicks: true,
          drawBorder: true,
          drawFill: true,
          drawTexts: false,
          drawPin: true,
  
          majorTicksColor: 'white',
          minorTicksColor: 'white',
  
          majorTicksLength: 10.0,
          minorTicksLength: 7.0,
          majorTicksWidth: 0.2,
          minorTicksWidth: 0.0025,
  
          fillColor: 'transparent',
          pinColor: 'white',
          pinRadius: 5.0,
  
          borderColor: 'white',
          borderWidth: 4.0,
  
          secondHandColor: 'white',
          minuteHandColor: '#fff',
          hourHandColor: '#fff',
  
          fontColor: '#fff',
          fontName: 'Tahoma',
          fontSize: 10.0,
  
          secondHandLength: 90.0,
          minuteHandLength: 70.0,
          hourHandLength: 50.0,
  
          secondHandWidth: 1.0,
          minuteHandWidth: 3.0,
          hourHandWidth: 4.0,
        }, {
          timezone: clock.data('timezone'),
        });
      });
      
    });
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js